import type { MessageHandlerDeps } from '../message-handler-deps.js';
import type { ApiToBridgeMessage } from '../../types/api-to-bridge-messages.js';
import { handleSkillCallMessage } from '../handlers/skill-call.js';
import { handleSkillLayoutRequest } from '../handlers/skill-layout-request.js';
import { handleInstallSkillsMessage } from '../handlers/install-skills.js';
import { handleInstallAgentMessage } from '../handlers/install-agent.js';
import { handleRefreshLocalSkills } from '../handlers/refresh-local-skills.js';

export function dispatchBridgeSkillsMessage(
  msg: Extract<
    ApiToBridgeMessage,
    { type: 'skill_call' | 'skill_layout_request' | 'install_skills' | 'install_agent' | 'refresh_local_skills' }
  >,
  deps: MessageHandlerDeps
): void {
  switch (msg.type) {
    case 'skill_call':
      handleSkillCallMessage(msg, deps);
      break;
    case 'skill_layout_request':
      handleSkillLayoutRequest(msg, deps);
      break;
    case 'install_skills':
      handleInstallSkillsMessage(msg, deps);
      break;
    case 'install_agent':
      handleInstallAgentMessage(msg, deps);
      break;
    case 'refresh_local_skills':
      handleRefreshLocalSkills(msg, deps);
      break;
  }
}
